// create by nieshu on 2018/11/6

import Vue from 'vue'
// utils
import Util from '@/utils/util'

Vue.filter('date', (val, fmt) => {
  return Util.dateFormat(val, fmt)
})
Vue.filter('transHTTP', (val) => {
  if (val && val.indexOf('http:') > -1) {
    return val.replace('http:', 'https:')
  }
  return val
})
Vue.filter('hideName', (val) => {
  if (val && val.length > 1) {
    return val[0] + '***' + val[val.length - 1]
  }
  return val
})
Vue.filter('plateNo', (val, p) => {
  if (val && val.length > 1) {
    return val.substr(0, 2) + p + val.substr(2, val.length - 1)
  }
  return val
})
Vue.filter('discount', (val, p) => {
  if (val && val.length > 1) {
    return val.split('.')[1]
  }
})

Vue.filter('toQuartile', (val) => {
  if (val) {
    return Util.toQuartile(val + '')
  }
  return val
})

Vue.filter('formatPhone', (val) => {
  if (val) {
    return (val + '').replace(/(\d{3})(\d{4})(\d{4})/, '$1 $2 $3')
  }
  return val
})

Vue.filter('formatCard', (val) => {
  if (val) {
    return (val + '').replace(/(\d{4})(?=\d)/g, '$1 ')
  }
  return val
})

export default 1
